<template>
  <div class="flex h-screen w-screen flex-col lg:flex-row">
    <NavBar :header-service="headerService" :nav-module-type="NAV_MENU_TYPE.HOME" />
    <RouterView></RouterView>
  </div>
</template>
<script setup lang="ts">
import { useHeaderService } from '@/composables/use-header-service';
import { NavBar, NAV_MENU_TYPE } from '@eureka/shared/nav-bar';
const { headerService } = useHeaderService();
</script>
